import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Tabs, Spin } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuthContext from '../../contexts/AuthContext';
import useErrorMessage from '../../utils/ErrorMessage';
import ProductDescription from './ProductDescription';
import ProductDocuments from './ProductDocuments';

const { TabPane } = Tabs;

const ProductTab = () => {
  const { t } = useTranslation();
  const { dispatchAPI } = useAuthContext();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const { message } = useErrorMessage();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get('type') || 'RCP';
  const getProducts = useCallback(async () => {
    setIsLoading(true);
    try {
      const { data } = await dispatchAPI('GET', {
        url: '/products?populate=quote,supplier,contract,sheet.file,ipid.file,cgv.file,needs.file,autre.file'
      });
      data.push({ name: 'AUTRE', type: 'AUTRE' });
      setProducts(data);
    } catch (e) {
      if (e.response) message(e.response.status);
    }
    setIsLoading(false);
    // eslint-disable-next-line
  }, []);

  const handleTabChange = (key) => {
    navigate({
      pathname: location.pathname,
      search: `?type=${key}`
    });
  };

  useEffect(() => {
    (async () => {
      await getProducts();
    })();
  }, [getProducts]);

  return (
    <>
      <Typography.Title
        level={4}
        style={{
          marginBottom: 16,
          textTransform: 'none',
          fontWeight: 500,
          fontFamily: 'PT Sans',
          letterSpacing: 0
        }}
      >
        {t('document_library.product')}
      </Typography.Title>
      <Spin spinning={isLoading}>
        <Tabs activeKey={activeTab} onChange={handleTabChange}>
          {products.map((product) => (
            <TabPane
              key={product.type}
              tab={
                <span
                  style={{
                    fontFamily: 'Oswald',
                    fontSize: 16,
                    letterSpacing: '0.15em'
                  }}
                >
                  {product.type}
                </span>
              }
            >
              <ProductDescription product={product} />
              <ProductDocuments product={product} />
            </TabPane>
          ))}
        </Tabs>
      </Spin>
    </>
  );
};

export default ProductTab;
